<div class="cardform">
  <mat-card>
    <mat-card-content>
      <form [formGroup]="cpfForm">
        <div class="step-content">
          <div class="header-section">
            <h2>Checkout de Staff</h2>
            <p>Digite o CPF ou escaneie o QR Code para realizar o checkout</p>
          </div>

          <!-- Campo CPF e Botões -->
          <div class="input-section">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Digite o CPF do staff</mat-label>
              <input matInput formControlName="cpf" placeholder="Digite o CPF do staff" (keyup.enter)= "onSearch()">
              <button matSuffix mat-icon-button (click)="onSearch()"  [disabled]="cpfForm.invalid || isLoading" aria-label="Buscar staff">
                <mat-icon *ngIf="!isLoading" >search</mat-icon>
                <mat-icon *ngIf="isLoading" class="spin">autorenew</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <div class="qr-section">
            <button mat-raised-button color="primary" type="button" (click)="onOpenQrScanner()" [disabled]="isLoading">
              <mat-icon>qr_code_scanner</mat-icon>
              Ler QR Code
            </button>
          </div>

          <!-- Mensagens de Status -->
          <div *ngIf="error" class="alert-error">
            <mat-icon>error</mat-icon>
            {{ error }}
          </div>
          <div *ngIf="success" class="alert-success">
            <mat-icon>check_circle</mat-icon>
            {{ success }}
          </div>
          <div *ngIf="!cpfForm.value.cpf && !volunteer && !error" class="alert-info">
            <mat-icon>info</mat-icon>
            Digite o CPF ou escaneie o QR Code para continuar
          </div>

          <!-- Card do Voluntário (antes do checkout) -->
          <div *ngIf="volunteer" class="volunteer-step-flex">
            <!-- Card do Voluntário -->
            <div class="volunteer-card">
              <h3>Dados do Voluntário</h3>
              <div class="volunteer-info">
                <p><strong>Nome Completo:</strong> {{volunteer.nomeCompleto}}</p>
                <p><strong>CPF:</strong> {{volunteer.cpf}}</p>
                <p><strong>Número Sistema:</strong> {{volunteer.numeroSistema}}</p>
                <p><strong>Nome Colete:</strong> {{volunteer.nomeColete}}</p>
                <p><strong>Comando Regional:</strong> {{volunteer.comandoRegional}}</p>
                <p><strong>Regional:</strong> {{volunteer.regional}}</p>
                <p><strong>Divisão:</strong> {{volunteer.divisao}}</p>
                <p><strong>Cargo:</strong> {{volunteer.cargo}}</p>
                <p><strong>Telefone:</strong> {{volunteer.telefoneCelular}}
                  <a *ngIf="volunteer.telefoneCelular"
                     [href]="getWhatsappLink(volunteer.telefoneCelular)"
                     target="_blank"
                     rel="noopener"
                     class="whatsapp-link"
                     title="Enviar mensagem no WhatsApp">
                    <img src="/assets/images/WhatsApp.png" alt="WhatsApp" style="height: 22px; vertical-align: middle;" />
                  </a>
                </p>
              </div>
            </div>

            <!-- Card de Staff se houver -->
            <div *ngIf="volunteer.staff" class="staff-card">
              <h3>Atuação Atual</h3>
              <div class="staff-info">
                <p><strong>Evento:</strong> {{volunteer.staff.currentEvent?.description || '-'}}</p>
                <p><strong>Tipo de Evento:</strong> {{volunteer.staff.currentEvent?.eventType?.name || '-'}}</p>
                <p><strong>Job:</strong> {{volunteer.staff.job?.description || '-'}}</p>
                <p><strong>Descrição:</strong> {{volunteer.staff.location?.description || '-'}}</p>
                <p><strong>Nome do Local:</strong> {{volunteer.staff.location?.name || '-'}}</p>
                <p><strong>Início:</strong> {{volunteer.staff.startAt ? (volunteer.staff.startAt | date:'dd/MM/yyyy HH:mm') : '-'}}</p>
              </div>
              <div class="card-action-staff">
                <mat-icon color="primary">info</mat-icon>
                <span>Voluntário está em um job ativo</span>
              </div>
            </div>

            <!-- Botão de Checkout e Deserção -->
            <div class="checkout-action">
              <mat-form-field appearance="outline" class="full-width" style="margin-bottom: 12px;">
                <mat-label>Descrição (opcional)</mat-label>
                <input matInput [(ngModel)]="description" name="description" placeholder="Motivo ou observação" [ngModelOptions]="{standalone: true}">
              </mat-form-field>
              <div style="display: flex; gap: 12px; flex-wrap: wrap; justify-content: center; margin-bottom: 5px;">
                <button mat-raised-button color="warn" type="button" (click)="performChangeJob(volunteer.id, volunteer.staff?.celebrationJobLocationUuid)"
                         [disabled]="!volunteer.staff" class="checkout-button">
                   <mat-icon>swap_horiz</mat-icon>
                   Trocar de posto
                 </button>
              </div>
              <div style="display: flex; gap: 12px; flex-wrap: wrap; justify-content: center;">
                <button mat-raised-button color="warn" type="button" (click)="performCheckout(volunteer.id)"
                        [disabled]="!volunteer.staff" class="checkout-button">
                  <mat-icon>logout</mat-icon>
                  Realizar Checkout
                </button>
                <button mat-raised-button color="accent" type="button" (click)="performDesertion(volunteer.id)"
                        [disabled]="!volunteer.staff" class="checkout-button">
                  <mat-icon>block</mat-icon>
                  Deserção
                </button>
              </div>
              <p *ngIf="!volunteer.staff" class="no-staff-message">
                <mat-icon>info</mat-icon>
                Este voluntário não possui job ativo para checkout
              </p>
            </div>
          </div>

          <!-- Loading -->
          <div *ngIf="isLoading" class="loading-section">
            <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
            <p>Processando checkout...</p>
          </div>

        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <!-- QR Scanner Modal -->
  <app-qr-code-scanner
    *ngIf="showQrScanner"
    (qrCodeScanned)="onQrCodeScanned($event)"
    (closeScanner)="onCloseQrScanner()">
  </app-qr-code-scanner>
</div>
